// Function to handle single content block removal (for the trash can button)

import { deleteImageFromS3 } from '../../../helpers/deleteImagefromS3';
import { extractS3Key } from '../../../helpers/extractS3Key';
import { TextBlock } from '../../../interfaces/textEditor.interface';

/**
 * Function to handle single content block removal (for the trash can button)
 * @param block
 * @param userId
 * @param draftId
 * @param arrayHelpers
 * @param index
 */
export const handleRemoveContentBlock = async (
  block: TextBlock,
  userId: string,
  draftId: string,
  arrayHelpers: any,
  index: number,
): Promise<void> => {
  try {
    // If it's an image block, delete from S3
    if (block.type === 'Image') {
      const imageUrl = block.data?.file?.url;
      if (imageUrl) {
        const imageKey = extractS3Key(imageUrl);
        if (imageKey) {
          await deleteImageFromS3(imageKey);
          console.log(`Image deleted from S3: ${imageKey}`);
        }
      }
    }

    // For all block types, we need to update the content.json in S3
    // This will be handled by the component's save mechanism when the block is removed from the UI

    // Remove from the UI array
    arrayHelpers.remove(index);

    console.log(
      `Content block removed from UI: ${block.type} at index ${index}`,
    );
  } catch (error) {
    console.error('Error removing content block:', error);
    // You might want to show a toast notification here
    throw error;
  }
};
